import React from 'react'

import { Skeleton } from '@fourthwall/components'

import { Onboarding as OnboardingComponent } from '../../../../../../../components/common/Onboarding'
import { useOverviewContext } from '../../hooks/useOverviewContext'

export const Onboarding = () => {
  const overview = useOverviewContext()

  if (overview.isLoading) {
    return (
      <Skeleton>
        <Skeleton.Shape width="100%" height={293} />
      </Skeleton>
    )
  }

  if (!overview.onboarding.active) {
    return null
  }

  return (
    <div>
      <OnboardingComponent
        progress={overview.onboarding.progress}
        onboardingListProps={{
          items: overview.onboarding.items,
        }}
        skipLabel={overview.onboarding.skipLabel}
        onSkip={overview.onboarding.onSkip}
      />
    </div>
  )
}
